import { Paint } from '../types/Paint';
import { Team } from '../types/teams';
import OAuthClient from './oauth.client';

class TeamsService {
  url = process.env.REACT_APP_RM_URL;
  oauth: OAuthClient;

  constructor() {
    this.oauth = new OAuthClient();
  }

  async list(search:string, page: Number, take: Number): Promise<Team[]> {
    return this.oauth.fetch(`${this.url}/teams/list?search=${search}&page=${page}&take=${take}`)
      .then(res => res.json());
  }

  async get(id: string): Promise<Team> {
    return this.oauth.fetch(`${this.url}/team/${id}`)
      .then(res => res.json());
  }
}

export default TeamsService;
